export default class UnifiedSignupIntent {
  public readonly intent;

  public static bizIntent = new UnifiedSignupIntent({ val: 'Business' });

  public static funIntent = new UnifiedSignupIntent({ val: 'Fun' });

  public static eduIntent = new UnifiedSignupIntent({ val: 'School' });

  public static standardIntent = new UnifiedSignupIntent({ val: 'Standard' })

  private static mappings: Record<string, UnifiedSignupIntent> = {
    Business: UnifiedSignupIntent.bizIntent,
    Fun: UnifiedSignupIntent.funIntent,
    School: UnifiedSignupIntent.eduIntent,
    Standard: UnifiedSignupIntent.standardIntent,
  };

  private constructor({
    val,
  }: {
    val: string,
  }) {
    this.intent = val;
  }

  public static fromString(val: string | number | boolean): UnifiedSignupIntent {
    const intent = UnifiedSignupIntent.mappings[`${val}`];
    if (!intent) throw new Error(`Could not find intent with val: '${val}'`);
    return intent;
  }

  public compareTo(rhs: UnifiedSignupIntent) {
    return this.intent === rhs.intent;
  }
}
